import React from "react";

const Input = ({ className = "", error = false, label, ...props }) => {
  const baseClasses =
    "block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-1 sm:text-sm";
  const normalClasses =
    "border-gray-300 focus:ring-slate-500 focus:border-slate-500";
  const errorClasses = "border-red-300 focus:ring-red-500 focus:border-red-500";

  const inputClasses = `${baseClasses} ${
    error ? errorClasses : normalClasses
  } ${className}`;

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input className={inputClasses} {...props} />
    </div>
  );
};

export { Input };
